const langMiscPlayerVideoTuto = {
	btn_open_player: {
		tag: 'misc.player_video_tuto.btn_open_player',
		fr: 'Découvrir le portail',
		en: 'Discover portal',
	},
	title: {
		tag: 'misc.player_video_tuto.title',
		fr: 'Découvrir le portail',
		en: 'Discover portal',
	},
};

export default langMiscPlayerVideoTuto;
